import type { Speaker } from '../../../generated/graphql-viewer';

import { Heading, classNames } from '@movingimage-evp/mi-ui-component-library';
import { useTranslation } from 'react-i18next';

import { Avatar } from '../../../components/avatar';
import { getInitials } from '../../../utils';

import styles from './speakers.module.css';

type Props = {
  speakers?: Speaker[] | null;
  /** Single-speaker only for now: at most one speaker is spotlighted at a time. */
  highlightedSpeakerId?: string;
};

export function Speakers({ speakers, highlightedSpeakerId }: Props) {
  const { t } = useTranslation();

  if (!speakers || speakers.length === 0) return null;

  return (
    <section className={styles.wrapper} data-testid="viewer-speakers">
      <Heading className={styles.title}>{t('viewer.views.stream.speakers.title')}</Heading>

      <ul className={styles.list}>
        {speakers.map((speaker) => {
          const isActive = highlightedSpeakerId !== undefined && speaker.id === highlightedSpeakerId;

          return (
            <li
              key={speaker.id}
              className={classNames(styles.speaker, isActive && styles.activeSpeaker)}
              data-testid="viewer-speaker"
              data-active={isActive}
            >
              <Avatar className={styles.avatar}>
                {speaker.pictureUrl ? (
                  <img className={styles.avatarImage} src={speaker.pictureUrl} alt="" />
                ) : (
                  getInitials(speaker.name)
                )}
              </Avatar>

              <span className={styles.name} data-testid="viewer-speaker-name">
                {speaker.name}
              </span>

              <span className={styles.position} data-testid="viewer-speaker-position">
                {speaker.position}
              </span>
            </li>
          );
        })}
      </ul>
    </section>
  );
}
